export var mixin = {
  methods: {
    checkPhone(area,phone) {
      let dator = new this.$Dator.Dator();
      let paterns = [{ strategy: "isEmpty",
      //  errMsg: "手機號碼不能爲空"
      errMsg:this.language('ui.placeholderPhone4')
       }];
      switch (area) {
        case "+86":
          paterns.push({
            strategy: "checkStringFormat:11:1",
            // errMsg: "請輸入正確的手機號碼",
            errMsg:this.language('login.tipsText14')
          });
          paterns.push({
            strategy: "checkPhone",
            // errMsg: "請輸入正確的手機號碼",
            errMsg:this.language('login.tipsText14')
          });
          break;
        case "+852":
        case "+853":
          paterns.push({
            strategy: "checkStringFormat:8:1",
            // errMsg: "請輸入正確的手機號碼",
            errMsg:this.language('login.tipsText14')
          });
          paterns.push({
            strategy: "checkNumber",
            // errMsg: "請輸入正確的手機號碼",
            errMsg:this.language('login.tipsText14')
          });
          break;
        case "+886":
          paterns.push({
            strategy: "checkStringFormat:9:1",
            // errMsg: "請輸入正確的手機號碼",
            errMsg:this.language('login.tipsText14')
          });
          paterns.push({
            strategy: "checkNumber",
            // errMsg: "請輸入正確的手機號碼",
            errMsg:this.language('login.tipsText14')
          });
          break;
      }

      if (area == "+852") {
        paterns.push({
          strategy: "checkHkPhone",
          // errMsg: "請核對並輸入正確手機號碼",
          errMsg:this.language('login.tipsText14')
        });
      }

      dator.add(phone, paterns);
      if (dator.getErrmsg()) {
        return dator.getErrmsg();
      } else {
        return "";
      }
    },
  },
};
